import {action, computed, observable, runInAction} from 'mobx'
import {message} from 'antd'
import {get, json} from '../../../../utils/ajax'

class BoutiqueAttrStore {

    @observable list
    @observable loading
    @observable modal
    @observable forms
    @observable searchForms
    @observable search
    @observable pagination
    @observable id
    @observable isSubmit
    @observable name
    @observable isDisabled
    @observable type
    @observable field

    constructor() {
        this.list = []
        this.loading = false
        this.modal = 'hide'
        this.forms = {}
        this.searchForms = {}
        this.search = {}
        this.pagination = {}
        this.id = ''
        this.isSubmit = false
        this.name = ''
        this.isDisabled = false
        this.type = ''
        this.field = ''
    }

    /**
     * 初始化页面
     */
    @action
    initListAttr = async (page) => {
        runInAction(() => {
            this.loading = true
            this.isSubmit = false
        })
        if (page) {
            page--
        } else if (this.pagination.page) {
            page = this.pagination.page - 1
        } else {
            page = 0
        }
        // 构建查询参数
        let search = {}
        Object.keys(this.searchForms).forEach(key => {
            search[`search.${key}`] = this.searchForms[key] ? this.searchForms[key] : ''
        })
        search.page = page
        search.size = 10
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/attr/list`, search)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.loading = false
            this.list = res.content
            this.page = {
                results: res.size,
                page: res.number + 1,
                total: res.totalElements
            }
        })
    }

    /**
     * 新增属性显示模式
     */
    @action showAddEdit = () => {
        runInAction(() => {
            this.loading = true
            this.forms = {}
            this.modal = 'show'
            this.id = ''
            this.loading = false
        })
    }

    /**
     * 平行化表单，传值给form
     */
    @computed
    get fields() {
        let fields = {
            id: {value: this.forms.id},
            name: {value: this.forms.name},
            type: {value: this.forms.type},
            field: {value: this.forms.field},
        }
        return fields
    }

    /**
     * 将表单时对象化，绑值给store。form
     */
    @action.bound
    onFormsChange = (changedFields) => {
        const fields = {...this.fields, ...changedFields}
        let forms = {
            id: fields.id.value,
            name: fields.name.value,
            type: fields.type.value,
            field: fields.field.value,
        }
        this.isDisabled = forms.name === this.name && forms.type === this.type && forms.field === this.field
        this.forms = forms
    }

    /**
     * 关闭模式
     */
    @action cancelAttr = () => {
        runInAction(() => {
            this.modal = 'hide'
            this.isSubmit = false
            this.isDisabled = false
        })
    }

    /**
     * 新增属性 + 修改属性
     */
    @action saveAttr = async () => {
        runInAction(() => {
            this.loading = true
        })
        if (!this.forms.id) {
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/attr/add`, {
                ...this.forms
            })
            if (res && res.status >= 400) {
                message.error('新增失败')
                return
            } else {
                runInAction(() => {
                    this.modal = 'hide'
                    message.success('保存成功')
                    this.forms = {}
                    this.loading = false
                })
                this.initListAttr(this.page)
            }
        } else {
            const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/attr/update`, {
                ...this.forms
            })
            if (res && res.status >= 400) {
                message.error('修改失败')
                return
            } else {
                runInAction(() => {
                    this.modal = 'hide'
                    message.success('修改成功')
                    this.forms = {}
                    this.loading = false
                    this.isDisabled = false
                })
                this.initListAttr(this.page)
            }
        }
    }

    /**
     * 初始化表单，可以不传参数，初始化全部为 null
     * @param id 根据id查询
     */
    @action initEdit = async (id) => {
        runInAction(() => {
            this.loading = true
            this.id = id
            this.isDisabled = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/attr/id/${id}`)
        runInAction(() => {
            if (res && res.status === 0) {
                return
            }
            this.name = res.name
            this.type = res.type
            this.field = res.field
            this.forms = res
            this.loading = false
            this.modal = 'show'
        })

    }

    /**
     * 删除
     */
    @action
    deleteAttrId = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/attr/delete?id=${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.loading = false
        })
        if (this.list.length === 1) {
            await this.initListAttr(this.pagination.page - 1)
        } else {
            await this.initListAttr(this.pagination.page)
        }
    }

    /**
     * 每次更新search框时，回写数据
     * @param values search数据
     */
    @action
    onSearchFieldChange(values) {
        runInAction(() => {
            this.search = values
        })
    }

    /**
     * 重置
     */
    @action
    fieldsReset() {
        runInAction(() => {
            this.loading = true
            this.searchForms = {}
            this.initListAttr(this.page)
            this.loading = false
        })
    }

    /**
     * 多条件查询
     * 平行化表单，传值给form
     */
    @computed
    get formFields() {
        let formFields = {
            name: {value: this.searchForms.name},
            type: {value: this.searchForms.type},
        }
        return formFields
    }

    /**
     * 多条件查询
     * 将表单时对象化，绑值给store。form
     */
    @action
    onFormChange = (changedFields) => {
        const fields = {...this.formFields, ...changedFields}
        let searchForms = {
            name: fields.name.value,
            type: fields.type.value,
        }
        this.searchForms = searchForms
    }

    @action
    handleBlur = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/attr/determineWhetherNameAlreadyExists`, {
            id: this.id,
            name: this.forms.name
        })
        runInAction(() => {
            if (res.name !== null) {
                this.forms.name = ''
                this.isSubmit = true
                return message.warn('此名称已存在，请重新输入')
            } else {
                this.isSubmit = false
            }
        })
    }
}

export default new BoutiqueAttrStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/BoutiqueCatalog/BoutiqueAttr/store.js